import type { ApiResponse, NamedItem, ReferenceKind } from '@/models/api'
import { api, readData } from '@/services/apiClient'

export interface ReferenceItemInput {
  percentage?: number | null
  id?: number | null
  name: string
  enabled?: boolean
  methodType?: number | null
  order?: number
}

export function loadReferenceData(kind: ReferenceKind): Promise<NamedItem[]> {
  return api.get<ApiResponse<NamedItem[]>>(`/reference-data/${kind}`).then(({ data }) => readData(data, []))
}

export function saveReferenceData(kind: ReferenceKind, item: ReferenceItemInput): Promise<void> {
  return api.post<ApiResponse<null>>(`/reference-data/${kind}`, {
    id: item.id ?? null,
    name: item.name,
    enabled: item.enabled ?? true,
    order: item.order ?? 0,
    methodType: item.methodType ?? 1,
    percentage: item.percentage ?? null,
  }).then(({ data }) => { readData(data, null) })
}

export function deleteReferenceData(kind: ReferenceKind, id: number): Promise<void> {
  return api.delete<ApiResponse<null>>(`/reference-data/${kind}/${id}`).then(({ data }) => { readData(data, null) })
}
